import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';

import { AlertService, StudentService, AuthenticationService } from '../_services';
import { Globals } from '../_helpers';

import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
@Component({
    selector: 'app-practical',
    templateUrl: './practical.component.html',
})
export class PracticalComponent implements OnInit {

    @ViewChild('overSwal') private overSwal: SwalComponent;
    @ViewChild('offSwal') private offSwal: SwalComponent;
    @ViewChild('noPracticalSwal') private noPracticalSwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    isError = false;
    loading = false;
    submitted = false;
    returnUrl: string;
    imagePath: string;
    over1: string;
    over2: string;
    over3: string;
    _over0: string
    _over1: string;
    _over2: string;
    errorMsg: string;


    students = [];
    localData = {};
    authenticationService: any;
    assessorName;
    activeExam = {};
    viva_assessor: number
    viva_pc: number = 0;
    practical_viva: number = 0;
    allowExamType: number = 0;
    examid:number = 0;    

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private studentService: StudentService,
        private alertService: AlertService,
        private globals: Globals
    ) { }

    ngOnInit() {
        this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.activeExam = JSON.parse(localStorage.getItem('activeExam_PS'));
        this.assessorName = this.localData['name_assessor'];
        this.imagePath = '/assets/images/pic-upload.png';
        this.over1 = '/assets/images/is_over=0.png';
        this.over2 = '/assets/images/is_over=1.png';
        this.over3 = '/assets/images/is_over=2.png';
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

        this.viva_assessor = this.activeExam['viva_assessor'];
        this.viva_pc = this.activeExam['vivapc'];
        this.practical_viva = this.activeExam['viva_practical'];
        this.examid = this.activeExam['exam_id'];        

        this.getStudentsData();
    }


    private getStudentsData() {
        this.submitted = true;
        this.studentService.practical(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.localData['exam_id'])
            .pipe(first())
            .subscribe(
                data => {
                    //console.log(data);
                    if (data.code == 1000) {
                        this.students = data.students;
                        this._over0 = data.zero
                        this._over1 = data.one
                        this._over2 = data.two
                        

                    }  else if(data.code == 1001){
                        this.isError = true;
                        this.noPracticalSwal.show(); 
 /*                       this.errorMsg = 'You do not have any Practical Exam. !!';*/
                    }
                    else if(data.status == 'COM_TOKEN_ERROR'){
                        this.loading = false;
                        this.router.navigateByUrl('/login');
                    }
            

                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            );
    }


    public refreshPage() {
        window.location.reload();
    }
    public over(vc:number){
        if(vc==2){
            this.overSwal.show();
            return;
        }
    }

    public marks(practical_id:number,student_id:number) {
        // localStorage.setItem('student_data', JSON.stringify(data));
        // this.router.navigateByUrl('/marks');
        this.router.navigate(['/marks', practical_id,student_id]);
    }

    public gotoDashboard(){
        this.router.navigateByUrl('/home/' + this.examid+'/'+this.viva_assessor+'/'+this.viva_pc+'/'+this.practical_viva);
    } 

    public reload(){
          window.location.reload();
    }  
    public video(id:number,stdid:number,login:number) {
        if(login==0){
            this.offSwal.show();
            return;
        }
        else{
            this.router.navigate(['/video', id,stdid]);
        }
    }
}

